module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__header__close-330c044dbaab4e8fcf527e3396662f1d.svg";